/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  CREATE_TRANSACTION: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.trag.createTransaction',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CREATE_TRANSACTION' },
      },
    },
    CREATE_TRANSACTION: {
      invoke: {
        id: 'createTransaction',
        src: 'createTransaction',
        onDone: {
          target: 'CREATE_TRANSACTION_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'CREATE_TRANSACTION_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    CREATE_TRANSACTION_SUCCESS: {
      type: 'final',
    },
    CREATE_TRANSACTION_FAILED: {
      on: {
        START: { target: 'CREATE_TRANSACTION' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
